angular.module('ui.shell')
    .directive('footerPanelView', function (customTemplateResolver) {
        return {
            restrict: 'E',
            replace: 'true',
            templateUrl: 'app/ui/shell/views/footerPanel.html', // customTemplateResolver.get('footerPanel.html', 'app/ui/shell/views/footerPanel.html')
            controller: function ($scope, $state) {
                $scope.currentDate = new Date();
            }
        };
    });